export enum ChangePlanStatusTypesEnum {
  PRIMARY = 'PRIMARY',
  TO_CONSIDER = 'TO_CONSIDER',
  ERROR = 'ERROR',
}
